export default __webpack_public_path__ + "static/media/5.30309862.jpg";